module.exports = __webpack_public_path__ + "img/reject.6220810a.svg";